module.exports = __webpack_public_path__ + "img/atencion_dimension.a4ff49cb.svg";